import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { User, GroupMember, UserBusinessUnits } from "types";
import UserForm from "components/Forms/UserForm/UserForm";
import { getUser, updateUser, hideToast } from "app/features/userSlice";
import { getGroups } from "app/features/groupsSlice";
import { getBusinesses } from "app/features/businessesSlice";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { getToastMessage } from "lib/helpers/toastMessageHelper";
import FormCard from "components/Forms/FormCard/FormCard";
import withAuth from "lib/hoc/withAuth";
import NewToast from "ui/atoms/NewToast";

const UserEdit = () => {
  const param = useParams();
  const dispatch = useAppDispatch();
  const userId = param.userId ?? "";
  const { user, loading, severity, response, showToast, error } = useAppSelector((state) => state.user) ?? [];
  const { groups } = useAppSelector((state) => state.groups) ?? [];
  const { businesses } = useAppSelector((state) => state.businesses) ?? [];

  const [groupSelected, setGroupSelected] = useState<GroupMember[]>([]);
  const [businessesSelected, setBusinessesSelected] = useState<UserBusinessUnits[]>([]);

  const onUpdateUser = async (user: User) => {
    await dispatch(updateUser(user));
  };

  useEffect(() => {
    dispatch(getGroups());
    dispatch(getBusinesses());
    dispatch(getUser(userId));
  }, []);

  useEffect(() => {
    const mapGroupAndBusiness = async () => {
      setGroupSelected(user.groupMembers);
      setBusinessesSelected(user.userBusinessUnits);
    };
    mapGroupAndBusiness();
  }, [user]);

  const onCloseToast = () => {
    dispatch(hideToast());
  };

  return (
    <>
      <NewToast open={showToast} setOpen={onCloseToast} severity={severity}>
        {getToastMessage(response, error)}
      </NewToast>
      <FormCard maxWidthCard={775} maxWidthContainer='md' title='Editar Usuario'>
        <UserForm
          IsEdition
          user={user}
          groups={groups}
          loading={loading}
          businesses={businesses}
          handleSubmit={onUpdateUser}
          groupSelected={groupSelected}
          setGroupSelected={setGroupSelected}
          submitButtonText='Actualizar Usuario'
          businessesSelected={businessesSelected}
          setBusinessesSelected={setBusinessesSelected}
        />
      </FormCard>
    </>
  );
};

export default withAuth(UserEdit);
